import view from './view'
import create from './create'

export default {
    view,
    create,
    tabs: {
        trendradars: 'Trend radar',
        participations: 'Invitations to trend evaluations'
    },
    title: 'Trend radar',
    pageTitle: 'TREND RADAR - OVERVIEW'
}
